import { FC } from 'react';
import { Box, LinearProgress, LinearProgressProps, Stack, StackProps, Typography, TypographyProps } from '@mui/material';

import { useNextAssertion } from '@modules/Assertions/hooks/useNextAssertion';

interface Props {
  slotProps?: {
    stack?: StackProps;
    linearProgress?: Omit<LinearProgressProps, 'value'>;
    typography?: TypographyProps & {
      longFormat?: boolean;
    };
  };
};

export const UserProgress: FC<Props> = ({ slotProps }) => {
  const { longFormat, ...restTypographyProps } = slotProps?.typography || {};

  const { status, next } = useNextAssertion();

  if (status !== 'success' || !next) {
    return null;
  }

  return (
    <Stack width="100%" direction="row" spacing={1} alignItems="center" {...slotProps?.stack}>
      <LinearProgress
        value={(next.totalAnswered / next.totalAssertions) * 100}
        variant="determinate"
        {...slotProps?.linearProgress}
        sx={{
          width: '100%',
          height: 8,
          borderRadius: 1,
          ...slotProps?.linearProgress?.sx,
        }}
      />
      <Box>
        <Typography variant="caption" fontWeight={600} color="textSecondary" noWrap {...restTypographyProps}>
          {longFormat ?
            `${next.totalAnswered} of ${next.totalAssertions} statements answered`
            : `${next.totalAnswered} / ${next.totalAssertions}`}
        </Typography>
      </Box>
    </Stack>
  );
};
